
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'Modal',
    props: {
      modalType: {
        type: String,
        required: false,
        default: 'warning',
        validator: (value: string): boolean => {
          return ['warning', 'form'].includes(value)
        },
      },
      headline: String,
      confirmBtnTxt: String,
    },
    emits: ['confirm', 'exit-modal'],
  })
